import React, { useEffect, useState } from 'react';
import { BOT_NAMES } from './botNames';
import { PLAYER } from '../playerData';
import { MAX_PLAYERS } from './config';
import { ASSETS } from '../assetManifest';

function Matchmaking({ gameInterface, onMatchReady, onFinishGame }) {
  const [matchmaking, setMatchmaking] = useState(true);
  const [startingMatch, setStartingMatch] = useState(false);
  const [usersList, setUsersList] = useState([]);
  const [matchReadyTriggered, setMatchReadyTriggered] = useState(false);
  
  useEffect(() => {
    const interval = setInterval(() => {
      if (gameInterface) {
        setUsersList(Object.values(gameInterface.users));
      }
    }, 10);

    return () => clearInterval(interval);
  }, [gameInterface]);
  
  useEffect(() => {
    const availableNames = [...BOT_NAMES];
    let botCount = 0;
    
    const addBot = () => {
      if (botCount >= MAX_PLAYERS - 1) return;
      
      const nameIndex = Math.floor(Math.random() * availableNames.length);
      const botName = availableNames.splice(nameIndex, 1)[0];
      const botId = `bot-${botCount}`;
      
      gameInterface.users[botId] = {
        sid: botId,
        name: botName,
        stats: { ...PLAYER.stats },
        is_bot: true
      };
      
      botCount++;
      
      if (Object.keys(gameInterface.users).length >= MAX_PLAYERS && !matchReadyTriggered) {
        setMatchmaking(false);
        setStartingMatch(true);
        setMatchReadyTriggered(true);
        setTimeout(() => {
          onMatchReady();
        }, 1200);
      }
    };
    
    const timeouts = [];
    for (let i = 0; i < MAX_PLAYERS - 1; i++) {
      const randomDelay = 500 + Math.random() * 3000;
      timeouts.push(setTimeout(addBot, randomDelay));
    }
    
    return () => {
      timeouts.forEach(clearTimeout);
    };
  }, [gameInterface, onMatchReady, matchReadyTriggered]);

  return (
    <div className="h-full w-full relative">
      <div 
        className="absolute inset-0 bg-cover bg-no-repeat"
        style={{
          backgroundImage: `url(${ASSETS.backgrounds.matchmaking_background.path})`,
          top: '-209px',
          left: '-731px',
          width: '1797px',
          height: '1198px'
        }}
      />
      
      <div className="relative z-10 flex flex-col items-center pt-[107px]">
        <span className="font-['Asap'] text-[24px] font-bold text-[#1F6AD9] leading-[36.672px] h-[50px] flex items-center justify-center w-[233px]">
          {matchmaking ? 'Finding players...' : startingMatch ? 'Starting' : 'Match Ready!'}
        </span>

        <div 
          className="w-[366px] h-[436px] mt-[45px] mx-auto relative"
          style={{
            backgroundImage: `url(${ASSETS.backgrounds.matchmaking_panel.path})`,
            backgroundSize: '100% 100%'
          }}
        >
          <div className="pt-[83px] flex flex-col items-center gap-[17px]">
            {usersList.map((user) => (
              <span
                key={user.sid}
                className="font-['Asap'] text-[24px] font-bold text-white leading-[28px] h-[28px] flex items-center justify-center w-[165px]"
              >
                {user.name}
              </span>
            ))}
          </div>
        </div>

        <span className="font-['Asap'] text-[32px] font-bold text-[#1F6AD9] leading-[36.672px] h-[50px] flex items-center justify-center w-[233px] mt-[96px]">
          {`Players : ${usersList.length}/${MAX_PLAYERS}`}
        </span>
      </div>

      <button
        onClick={onFinishGame}
        className="absolute bottom-4 left-4 px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded font-['Asap']"
      >
        Leave
      </button>
    </div>
  );
}

export default Matchmaking;
